import { useEffect, useRef, useState } from "react";
import { animate, useInView } from "framer-motion";
import { Reveal, Eyebrow } from "../components/Reveal";
import { METRICS } from "../data/content";

const Counter = ({ value, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value]);

  return (
    <span ref={ref} className="tabular-nums">
      {display.toLocaleString()}
      {suffix}
    </span>
  );
};

export const Experience = () => (
  <section id="expertise" data-testid="experience-metrics-section" className="bg-[#0B132B] py-24 lg:py-36 border-y border-white/[0.06]">
    <div className="max-w-7xl mx-auto px-6 sm:px-10">
      <Reveal>
        <Eyebrow dark>Founder Career Experience</Eyebrow>
        <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.12] text-[#F8F9FA] mt-6 max-w-3xl">
          Experience across the entire <em className="italic text-teal-300">translational pathway.</em>
        </h2>
        <p className="mt-6 text-slate-400 text-base max-w-2xl leading-relaxed">
          The judgment behind Calliope's advisory practice was earned in the operating seat —
          leading programs, organizations and boards through every stage of development.
        </p>
      </Reveal>

      <div className="mt-16 grid grid-cols-2 lg:grid-cols-5 border border-white/10 divide-x divide-y lg:divide-y-0 divide-white/10" data-testid="metrics-grid">
        {METRICS.map((m, i) => (
          <Reveal key={m.label} delay={i * 0.08} className="p-6 sm:p-8">
            <p className="font-serif text-4xl sm:text-5xl text-teal-300" data-testid={`metric-value-${i}`}>
              <Counter value={m.value} suffix={m.suffix} />
            </p>
            <p className="mt-3 text-sm font-semibold text-slate-200 tracking-wide">{m.label}</p>
            <p className="mt-2 text-xs text-slate-500 leading-relaxed">{m.note}</p>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.25em] text-slate-600" data-testid="metrics-disclaimer">
          Figures reflect Dr. Aspeslet's executive career experience prior to founding Calliope.
        </p>
      </Reveal>
    </div>
  </section>
);
